/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 21/11/2023
 */

import { Box, Button, Container, Paper, Toolbar, Typography } from "@mui/material"
import { useState , useEffect } from "react";
import { useDispatch } from "react-redux"
import SearchBar from "../Components/Shared/SearchBar";
import AreaDialog from '../Components/Area/AreaDialog';
import AreaList from "../Components/Area/AreaList";
import { useGetAllAreasQuery } from "../Store/Services/AreaService";
import { closeAreaModal, openAddAreaModal } from "../Store/Slices/areaSlice";

import styles from "./Management.module.css"

const AreaManagement = () => {
    const dispatch = useDispatch();
    const [searchData, setSearchData] = useState([])
    const { data, isSuccess, isLoading } = useGetAllAreasQuery();

    const handleClose = () => {
        dispatch(closeAreaModal());
    }

    const roles = sessionStorage.getItem("roles");

    return (
        roles?.split(",").includes("PRIV_ES_DISPLAY_AREAS") ? (
        <Paper elevation={3} className={styles.pageContainer} style={{backgroundImage: `url(${process.env.REACT_APP_IMAGE_URL}E_SERVICE/thumbnail_Management.png)`}}>
            <Box>
                <Toolbar className={styles.subNavBar}>
                    <Typography className={styles.topic}>Area Management</Typography>
                    {roles?.split(",").includes("PRIV_ES_ADD_AREA") ?  (<Button variant="contained" color="primary" className={styles.buttonItem} onClick={() => dispatch(openAddAreaModal())}>Add Area</Button>) : null}
                </Toolbar>
            </Box>
            <Container id={styles.container}>
                <SearchBar
                    data={isSuccess || isLoading ? data : []}
                    setSearchData={setSearchData}
                    text="Search Areas"
                    search="area"
                />
            </Container>

            <Container>
               {isSuccess && <AreaList data={Array.isArray(searchData) && searchData.length > 0 ? searchData : data} />}
            </Container>

            <AreaDialog handleClose={handleClose} />
        </Paper> ) : null
    )
}

export default AreaManagement
